import { render, staticRenderFns } from "./controls.vue?vue&type=template&id=68505684&scoped=true&"
import script from "./controls.vue?vue&type=script&lang=js&"
export * from "./controls.vue?vue&type=script&lang=js&"
import style0 from "./controls.vue?vue&type=style&index=0&id=68505684&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68505684",
  null
  
)

export default component.exports